import { createSimpleFunctional } from '../../util/helpers';

import VDataTable from './VDataTable';
import VEditDialog from './VEditDialog';

VDataTable.install = function install(Vue) {
  var VTableOverflow = createSimpleFunctional('table__overflow');

  Vue.component(VDataTable.name, VDataTable);
  Vue.component(VEditDialog.name, VEditDialog);
  Vue.component('v-table-overflow', VTableOverflow);
};

export default VDataTable;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VDataTable/index.js
// module id = LmeB
// module chunks = 0